import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild, ViewChildren
} from '@angular/core';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { ICreateEPrijemnicaCommand, IEOtpremnicaDto, TipAkcizneKategorije } from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import { FormArray } from '@angular/forms';
import { KreiranjePrijemniceFormService } from '../../prijemnice/kreiranje-prijemnice-form.service';
import { PredmetStavkeResult } from '../rezultat-pretrage-stavke/rezultat-pretrage-stavke.component';
import { EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import {
  AddOznakaFormComponent
} from '../../../../../racun/src/lib/info/oznake-racuna-info/add-oznaka-form/add-oznaka-form.component';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import { DialogSize } from '../../../../../../shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import {
  AddKomentarStavkePrijemniceComponent
} from '../add-komentar-stavke-prijemnice/add-komentar-stavke-prijemnice.component';

@Component({
  selector: 'kodit-stavke-eprijemnice-table',
  templateUrl: './stavke-eprijemnice-table.component.html',
  styleUrls: ['./stavke-eprijemnice-table.component.scss']
})
export class StavkeEprijemniceTableComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  stavkePrijemnice: FormArray;
  tipDuvan: TipAkcizneKategorije = TipAkcizneKategorije.DUVAN;
  rezultatiSearchValue: string;
  shouldDisplayRezultate: boolean;
  redniBrojZaRezultate: number = 0;
  disabledStavka: boolean = false;
  prethodniMagacinId: any = null;

  /** Configurations */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(DialogSize.SMALL);

  /** I/O */
  @Input() form: FormGroupTypeSafe<ICreateEPrijemnicaCommand>;

  constructor(
    private _fs: KreiranjePrijemniceFormService,
    private _formService: EotpremnicaFormService,
    private _dialogService: DynamicDialogService
  ) { }

  ngOnInit(): void {
    this.stavkePrijemnice = this._fs.getStavkeArray;

    this.stavkePrijemnice.controls.forEach(stavkaCtrl => {
      const pristiglaCtrl = stavkaCtrl.get('pristiglaKolicina');
      const primljenaCtrl = stavkaCtrl.get('primljenaKolicina');
      const vracenaCtrl = stavkaCtrl.get('vracenaKolicina');

      if (!pristiglaCtrl || !primljenaCtrl || !vracenaCtrl) {
        return;
      }

      this._subs.add(
        pristiglaCtrl.valueChanges.subscribe(pristigla => {
          const vracena = Math.max(0, (pristigla ?? 0) - (primljenaCtrl.value ?? 0));
          vracenaCtrl.patchValue(vracena, { emitEvent: false });
        })
      );

      this._subs.add(
        primljenaCtrl.valueChanges.subscribe(primljena => {
          const vracena = Math.max(0, (pristiglaCtrl.value ?? 0) - (primljena ?? 0));
          vracenaCtrl.patchValue(vracena, { emitEvent: false });
        })
      );

      this._subs.add(
        vracenaCtrl.valueChanges.subscribe(vracena => {
          const primljena = Math.max(0, (pristiglaCtrl.value ?? 0) - (vracena ?? 0));
          primljenaCtrl.patchValue(primljena, { emitEvent: false });
        })
      );
    });

    if(this._fs.getFormObject?.get('magacinId')?.value === null)
    {
      this.disabledStavka = true;
    }

    this._fs.getFormObject?.get('magacinId')?.valueChanges.subscribe(magacinId => {

      if (magacinId === this.prethodniMagacinId) {
        return;
      }

      this.prethodniMagacinId = magacinId;

      this.disabledStavka = magacinId == null;
    });
  }

  updateRezultate(changedNaziv: string, stavkaIndex: number) {
    if (!changedNaziv || changedNaziv === '') {
      if (this.stavkePrijemnice.value[stavkaIndex]?.predmetStavkeDto?.id > 0) {
        this.redniBrojZaRezultate = 0;
        this.shouldDisplayRezultate = false;
      }
    } else {
      this.redniBrojZaRezultate = stavkaIndex;
      this.rezultatiSearchValue = changedNaziv;
      this.shouldDisplayRezultate = true;
    }
  }

  handleAddPredmetStavke(data: PredmetStavkeResult) {
    if (data == null || data.predmetStavke == null) {
      this.resetRezultati();
      return;
    }

    this._fs.patchPredmetStavke(
      data.predmetStavke,
      this.redniBrojZaRezultate
    );

    this.resetRezultati();
  }

  resetRezultati() {
    this.redniBrojZaRezultate = -1;
    this.shouldDisplayRezultate = false;
  }


  openDialogKomentar(rowIndex: number) {
    this.dialogConfig.data = { index: rowIndex};
    this.dialogConfig.header = 'Dodavanje komentara';
    this.dialogConfig.customSubmitButton = {
      label: 'Dodaj',
      icon: 'fas fa-plus',
    } as any;

    const ref = this._dialogService.open(
      AddKomentarStavkePrijemniceComponent,
      this.dialogConfig
    );

    this._subs.add(
      ref.onClose.subscribe((result) => {
        if (result) {
          //this.oznake = this.oznake.concat(result);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
